import ModelInterface from 'src/models/ModelInterface'
import {RawMessage, ISendStatus} from '@/types/entity/RawMessage'
import { MSGR_VK, MSGR_TG, MSGR_VB, MESSAGE_TYPE_POLL, MESSAGE_TYPE_MAILING, MESSAGE_TYPE_NOTIFY, MESSAGE_TYPE_MANAGER} from '@/constants';
import {DateTime} from 'luxon'

// @ts-ignore
import messages from '@/lang/index';

const MSG_TYPES_MAP: {[key: string]: {label: string}} = {
  [MESSAGE_TYPE_POLL]: {
    label: messages.polls.poll
  },
  [MESSAGE_TYPE_MAILING]: {
    label: messages.common.sidebar_links.newsletters.main_staff
  },
  [MESSAGE_TYPE_NOTIFY]: {
    label: messages.labels.automate_message
  },
  [MESSAGE_TYPE_MANAGER]: {
    label: messages.labels.send_from_vk
  },
}

class Message extends ModelInterface<RawMessage> {

  constructor (data: RawMessage) {
    super(data)
  }

  public getText () {
    return this.data.text || this.data.body && this.data.body.text || ''
  }

  public getAction () {
    return this.data.body && this.data.body.action || ''
  }

  public getActionVal () {
    const action = this.getAction();
    // "vote:5e9ec960f5e16b0006e27190:1"
    if (action) {
      return action.split(':')[2] || ''
    }
    return ''
  }

  public getType () {
    return this.data.type || ''
  }

  public getTo () {
    return this.data.to || {}
  }

  public getToName () {
    let user = this.getTo().staffuser || this.getTo().lsnuser
    if (user) {
      return [user!.last_name, user!.first_name, user!.middle_name].join(' ')
    }
    return ''
  }

  public getFrom () {
    return this.data.from
  }

  public getFromName () {
    let user = this.getFrom().staffuser || this.getFrom().lsnuser
    if (user) {
      return [user!.last_name, user!.first_name, user!.middle_name].join(' ')
    } else {
      if (MSG_TYPES_MAP[this.getType()]) {
        return MSG_TYPES_MAP[this.getType()].label || messages.labels.automate_message
      } else {
        return messages.labels.unknown_message_type
      }
    }
  }

  public getMsgrs () {
    return this.data.mgrs;
  }

  public getMsgrsArray () {
    let msgrs = this.getMsgrs()
    const arr: ISendStatus[] = []
    if (msgrs[MSGR_VK]) arr.push(msgrs[MSGR_VK]!)
    if (msgrs[MSGR_TG]) arr.push(msgrs[MSGR_TG]!)
    if (msgrs[MSGR_VB]) arr.push(msgrs[MSGR_VB]!)
    return arr;
  }

  public getMsgrStatus (key: string) {
    // @ts-ignore
    return this.getMsgrs()[key] && this.getMsgrs()[key].status || ''
  }

  public getTs (): number {
    return this.data.ts || 0
  }

  public getVote () {
    return this.data.vote
  }

  public getSendTime (): string {
    let ts = this.getTs()
    return DateTime.fromMillis(ts).toFormat('HH:mm');
  }

  public getSendDate (format: string): string {
    let ts = this.getTs()
    return DateTime.fromMillis(ts).setLocale('ru').toFormat(format || 'dd.LL.yyyy');
  }

  get ts () {
    return this.getTs();
  }

}

export default Message